var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$root.isMobile())?_c('CalendarMobile'):_c('CalendarDesktop'),_c('Tour',{attrs:{"name":"calendar-tour","steps":_vm.steps,"start":_vm.$store.getters.user.onboarding.show_calendar_tour && _vm.$planExist(),"onboardingVariable":"show_calendar_tour"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }